import { render, staticRenderFns } from "./VisorPedidos.vue?vue&type=template&id=050886df&scoped=true"
import script from "./VisorPedidos.vue?vue&type=script&lang=js"
export * from "./VisorPedidos.vue?vue&type=script&lang=js"
import style0 from "./VisorPedidos.vue?vue&type=style&index=0&id=050886df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050886df",
  null
  
)

export default component.exports